// extracted by mini-css-extract-plugin
export default {"h4":"H4-module__h4___uNj30","bold":"H4-module__bold___Hc_b0","muted":"H4-module__muted___BCUJj","inline":"H4-module__inline____oqUB"};